import app from 'app';
import RCP from '@wochitnpm/rcp';
import TimelineGatewayController from 'c/TimelineGatewayController';
import RcpControlPanel from 'v/assetModal/RcpControlPanel.vue';

export default app.Marionette.Object.extend({
  eventNamespace: '.inAssetRtpPlayerController',

  onBeforeDestroy: function () {
    $(document).off(this.eventNamespace);
    this.rcpPanel && this.rcpPanel.$destroy();
    this.rcp && this.rcp.destroy();
    this.rcpPanel = null;
    this.rcp = null;
  },

  initialize: function (options) {
    this.$box = options.$box;
    this.volumeControl = options.volumeControl;
    this.onVoPlayVolumeControl = options.onVoPlayVolumeControl;
    this.displayStartTime = options.displayStartTime;
    this.displayDuration = options.displayDuration;
    this.displayEndTime = options.displayEndTime;
    this.bgMusic = options.bgMusic;
    this.narrationAssets = options.narrationAssets;
    this.assetUUID = options.assetUUID;
    this.assetType = options.assetType;
    this.loop = options.loop;
    this.canPlay = options.canPlay;
    this.removeCurtains = options.removeCurtains;
    /** parts currently present in rcp */
    this._parts = [];
    this.state = new Backbone.Model({
      mode: null, // 'FINAL' || 'PARTIAL'
    });

    this.rcp = new RCP({
      showDiagnostic: false,
      el: this.$box.find('#js-rcp-playbox-1')[0],
      width: 688,
      height: 387,
      innerAspectRatio: this.removeCurtains
        ? app.ASPECT_RATIOS.ASPECT_16_9.ratio
        : app.ASPECT_RATIOS[app.currentAspectRatio].ratio,
    });

    if (options.commonVolume) {
      app.setCommonRCPVolume(this.rcp);
    }
    this.rcpPanel = new RcpControlPanel({
      el: this.$box.find('[for="mount-RcpControlPanel"]')[0],
      rcp: this.rcp,
    });

    // setup RCP event dispatcher proxy for the parent
    this.rcp.on(RCP.MSG.PLAYING, (time) => {
      this.trigger(RCP.MSG.PLAYING, time);
    });

    // toggle play on hitting spacebar
    if (this.canPlay) {
      $(document).on('keydown' + this.eventNamespace, (e) => {
        if (
          $.ui.keyCode.SPACE === e.which &&
          (!$(e.target).isEditable() ||
            $(e.target).hasClass('js-allow-rcp-play-space')) &&
          this.$box.is(':visible') &&
          _.isEmpty(this.$box.closest('.wt-loading-rtprd'))
        ) {
          e.preventDefault();
          this.rcp.togglePlay();
        }
      });
    }
  },

  setDisplayDuration: function (displayDuration) {
    this.displayDuration = displayDuration;
  },

  pause: function () {
    this.rcp.pause();
  },

  reset: function () {
    this.resetParts();
    this.rcp.reset();
  },

  play: function () {
    this.rcp.play();
  },

  show: function () {
    this.$box.show();
  },

  hide: function () {
    this.pause();
    this.$box.hide();
  },

  toggleLoop: function (loop) {
    if (_.isDefined(loop)) {
      this.loop = loop;
    }
    this.rcp.toggleLoop(this.loop);
  },

  reflectVolumeChange: function ({ volumeControl, onVoPlayVolumeControl }) {
    this.volumeControl = volumeControl;
    this.onVoPlayVolumeControl = onVoPlayVolumeControl;

    _.each(this.rcp.playList.feed.visual, (visual) => {
      visual.volumeControl = volumeControl;
      visual.onVoPlayVolumeControl = onVoPlayVolumeControl;
    });

    this.rcp.anode.emit(this.rcp.ns.Channel.MSG.CHANGE);
  },

  updateCrop: function (agd) {
    if (this.rcp.playList.feed.visual.length === 0) {
      return;
    }
    this.rcp.playList.feed.visual[0].cropValues = {
      scale: agd.scale,
      offset: agd.offset,
    };
    this.rcp.movie.channels.visual.draw();
  },

  marshalPreviewParts: function (rtp, play = true) {
    this.state.set('mode', 'PARTIAL');

    const state = {
      rtpParts: rtp.get('parts'),
      parts: [],
      isFirst: false,
      hasLast: false,
      newParts: [],
    };

    // normalize order of the `state.rtpParts`
    // i.e: allow following state.parts := [undefined, {}, undefined, {}]
    _.each(state.rtpParts, (part, key) => {
      /*
      (key) 'AUDIO': {
          data: {cdnUrl},
          message: 'DONE'             // or NA
      }
      */
      if ('AUDIO' === key) {
        if (!this._audioPart) {
          this._audioPart = {
            available: part.message === 'DONE',
            cdnUrl: part.data && part.data.cdnUrl,
            added: false,
          };
        }
        return true; // continue;
      }

      /* single part
      (key) 0002: (part) {
          data: {cdnUrl, duration}   // actual data
          message:"DONE"             // or COMPLETED
          timestamp:1481817902       // unix timestamp
      }
      */
      const iPartNumber = parseInt(key, 10);
      if ('0000' === key && _.isEmpty(this._parts)) {
        state.isFirst = true;
      }
      part.data.number = iPartNumber;
      if ('COMPLETED' === part.message) {
        state.hasLast = true;
        part.data.isLast = true;
      }
      state.parts[iPartNumber] = part.data;
    });

    // add only if this._parts.length exists in state.parts
    for (let i = this._parts.length, I = state.parts.length; i < I; i++) {
      if (state.parts[i]) {
        state.newParts.push(state.parts[i]);
      } else {
        break;
      }
    }

    if (state.newParts.length) {
      if (state.isFirst) {
        this.rcp.reset();
        this._addNarrations();
        this._addBGMusic();
        this.toggleLoop();
      }

      if (
        this._audioPart &&
        this._audioPart.available &&
        !this._audioPart.added
      ) {
        console.info('RTPPC::Part AUDIO');
        this._addAudioPart(this._audioPart.cdnUrl);
        this._audioPart.added = true;
      }

      _.each(state.newParts, (part) => {
        console.info(`RTPPC::Part #${part.number}`, part.isLast ? 'last' : '');
        this.rcp.append({
          play: play,
          item: {
            type: 'video',
            src: app.prependHttp(part.cdnUrl),
            blob: true,
            play: { duration: part.duration },
            volume: 0.0,
            volumeControl: this.volumeControl,
            onVoPlayVolumeControl: this.onVoPlayVolumeControl,
            origin: `Part #${part.number}`,
          },
        });
        this._parts.push(part);
      });
    }

    if (!play) {
      this.rcp.seek(0);
    }

    if (state.isFirst) {
      this.rcpPanel.time.total = this.displayDuration;
    } else if (state.hasLast) {
      this.rcpPanel.time.total = this.rcp.playList.feed.totalDisplayTime;
    }

    this.rcpPanel.time.buffered = _.sumBy(this._parts, function (part) {
      return part.duration;
    });

    if (state.hasLast && this._parts.length === state.parts.length) {
      this.resetParts();
    }

    if (state.isFirst) {
      app.doctorController.reportPreviewStreaming(
        this.assetUUID,
        this.assetType,
        Date.now() - rtp.get('startTime')
      );
    }
  },

  /**
   * reset parts to prepare before new rtp
   */
  resetParts: function () {
    this._parts = [];
    this._audioPart = null;
  },

  // setRtpModel: function(rtpModel) {
  //   const state = {
  //     hasParts: !_.isEmpty(rtpModel.get('parts')),
  //     url: rtpModel.get('realTimePreviewResultData').cdnUrl,
  //   };

  //   this.resetParts();
  //   if (state.hasParts) {
  //     rtpModel.unset('parts');
  //   } else {
  //     this.setStaticUrl({src: state.url});
  //   }
  // },

  setStaticUrlOverlayAsset: function ({
    asset,
    ignoreRtp = true,
    play = false,
  }) {
    const clone = _.cloneDeepAndClean(asset);
    const ot = clone.overlayTracks[0];
    const startTime = ot.displayStartTime;
    const duration = ot.displayDuration;

    this.state.set('mode', 'FINAL');
    this.rcp.reset();
    this._addNarrations();
    this._addBGMusic(startTime);
    this.toggleLoop();
    ot.displayStartTime = 0;
    ot.displayDuration = duration;
    ot.displayEndTime = duration;
    const item = TimelineGatewayController.createPlayerVisualTrack({
      asset: clone,
      ignoreRtp,
      addStartTime: false,
    });
    item.play.from = 0;
    item.play.duration = duration;
    item.play.until = item.play.from + duration;
    if (item.fragment) {
      item.fragment.from += startTime;
      item.fragment.duration = duration;
      item.fragment.until = item.fragment.from + duration;
    }
    this.setDisplayDuration(duration);

    this.rcp.append({ play, item });

    if (!play) {
      this.rcp.seek(0);
    }

    this.rcpPanel.time.total = this.displayDuration;
    this.rcpPanel.time.buffered = this.rcpPanel.time.total;
  },

  setStaticUrl: function ({
    asset,
    ignoreRtp = true,
    play = false,
    ignoreCropping = false,
    fitCanvasToImage = false,
    ignoreOverlay = false,
  }) {
    this.state.set('mode', 'FINAL');
    this.rcp.reset();

    this._addNarrations();
    this._addBGMusic();
    this.toggleLoop();
    const item = TimelineGatewayController.createPlayerVisualTrack({
      asset,
      ignoreRtp,
      ignoreCropping,
      ignoreOverlay,
      addStartTime: false,
    });
    if (fitCanvasToImage) {
      this.rcp.ctx.canvas.height =
        app.ASSET_EDITOR_WIDTH * (asset.metadata.height / asset.metadata.width);
      this.rcp.ctx.canvas.style.height = 'auto';
      this.rcpPanel.$el.style.display = 'none';
    }
    this.rcp.append({ play, item });

    if (!play) {
      this.rcp.seek(0);
    }

    this.rcpPanel.time.total = this.displayDuration;
    this.rcpPanel.time.buffered = this.rcpPanel.time.total;
  },

  _addNarrations: function () {
    _.each(this.narrationAssets, (audioAsset, i) => {
      const play = { from: null, duration: null, until: null };
      const frag = { from: null, duration: null, until: null };

      play.from = Math.max(
        0,
        audioAsset.displayStartTime - this.displayStartTime
      );
      play.until = Math.min(
        audioAsset.displayEndTime - this.displayStartTime,
        this.displayDuration
      );
      play.duration = play.until - play.from;

      frag.from =
        Math.max(0, this.displayStartTime - audioAsset.displayStartTime) +
        audioAsset.relativeStartTime;
      frag.duration = play.duration;
      frag.until = frag.from + frag.duration;

      this.rcp.append({
        play: false,
        item: {
          type: 'audio',
          src: app.prependHttp(audioAsset.cdnUrl),
          play: play,
          fragment: frag,
          // @DEL: volume: this.volumeSettings.narration,
        },
      });
    });
  },

  _addBGMusic: function (offset = 0) {
    if (!this.bgMusic) {
      return;
    }

    const play = { from: null, duration: null, until: null };
    const frag = { from: null, duration: null, until: null };

    play.from = 0;
    frag.from = this.displayStartTime + offset;
    play.duration = Math.min(
      this.displayDuration,
      this.bgMusic.duration - frag.from
    );
    frag.duration = play.duration;
    frag.until = frag.from + frag.duration;

    this.rcp.append({
      play: false,
      item: {
        type: 'bgMusic',
        src: app.prependHttp(this.bgMusic.hiResAssetUrl),
        // play: play,
        fragment: frag,
        // @DEL: volume: this.volumeSettings.bgMusic,
      },
    });
  },

  _addAudioPart: function (url) {
    this.rcp.append({
      play: false,
      item: {
        type: 'audio2',
        src: app.prependHttp(url),
        play: { duration: this.displayDuration },
        // @DEL: volume: this.volumeSettings.video,
      },
    });
  },
});
